import ImpresionProductos from './ImpresionProductoContainer';
export { ImpresionProductos };
